import { render, staticRenderFns } from "./createform.vue?vue&type=template&id=7a00d968&scoped=true"
import script from "./createform.vue?vue&type=script&lang=js"
export * from "./createform.vue?vue&type=script&lang=js"
import style0 from "./createform.vue?vue&type=style&index=0&id=7a00d968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a00d968",
  null
  
)

export default component.exports